export default {
  getAmazonSettingList: {
    url: '/amazon/profit/settings/list',
    method: 'post',
    desc: '利润自定义计算'
  },
  updateAmazonProfitSetting: {
    url: 'amazon/profit/settings/updateBatch',
    method: 'post',
    desc: '更新利润自定义计算'
  }
}
